(() => {
  window.swinger.observer.initialize('.swinger-widget', (elem) => {
    const type = elem.getAttribute('data-type').trim();
    const widgetSrc = `${window.swinger.config.assetsBase}/widgets/${type}${!window.swinger.supportsModules ? '.es5' : ''}.js?v=${window.swinger.config.version}`;

    window.swinger.resourceLoader.script(widgetSrc);
  }, false);

  window.swinger.observer.initialize('script[type="swinger/state"]', (elem) => {
    const id = elem.getAttribute('data-id').trim();
    const initialState = elem.textContent;

    window.swinger.widgets.states[id] = JSON.parse(initialState);
  }, false);
})();
